import React, { useEffect, useState, useRef } from "react"

import RentInformButton from "../for-mansion-objects/RentInformButton";
import { convertPrice, GetExchangeRates } from "../../helpers/currencyConvertor"
import { spacefyNumber, getAllSiblings } from "../../helpers/littleHelpers"

const PriceSection = (props) => {
    const initialCurrency = props.currencyOfSell ? props.currencyOfSell : props.currencyOfRent;
    const [activeCurrency, setActiveCurrency] = useState(initialCurrency);
    const [priceToSell, setPriceToSell] = useState(Infinity)
    const [priceToRent, setPriceToRent] = useState(Infinity)
    
    let initialOrder;

    if (initialCurrency === "RUB") {
        initialOrder = {
            rubOrder: 2,
            usdOrder: 1,
            eurOrder: 3
        }
    } if (initialCurrency === "USD") {
        initialOrder = {
            rubOrder: 1,
            usdOrder: 2,
            eurOrder: 3
        }
    } if (initialCurrency === "EUR") {
        initialOrder = {
            rubOrder: 1,
            usdOrder: 3,
            eurOrder: 2
        }
    }

    const [currencyOrder, setCurrencyOrder] = useState(initialOrder);
    const [pricesWrapped, setPricesWrapped] = useState(false);
    const [windowWidth, setWindowWidth] = useState();

    const lastCalledClickOnCurrency = useRef(0);
    const currencyChangeDelay = 300;
    
    let rates = GetExchangeRates();

    useEffect(() => {
        if (props.priceOnDemand === false) {
            setPriceToSell(props.priceToSell)
            if (activeCurrency === props.currencyOfRent) {
                setPriceToRent(props.priceToRent)
            } else {
                setPriceToRent(convertPrice(props.priceToRent, props.currencyOfRent, activeCurrency, rates))
            }
        
        } else {
            return;
        }
    }, [rates])
    
    const controlWrap = (addListener = true) => {
        if (props.priceOnDemand === false && props.sellPossible && props.rentPossible && (window.innerWidth < 600 || window.innerHeight < 600)) {
            let pricesElements = document.getElementsByClassName("priceSection")[0].children;
            
            if (pricesElements[0].offsetTop !== pricesElements[1].offsetTop) {
                setPricesWrapped(true);
            } else {
                setPricesWrapped(false);
            }

            if (addListener === true) {
                window.addEventListener('resize', () => {
                    setWindowWidth(window.innerWidth)
                });
            }
        }
    }

    useEffect(() => {
        controlWrap();
    }, [windowWidth, rates]);

    const handleClickOnCurrency = (e) => {
        e.preventDefault()
        let now = new Date().getTime();
        if (now - lastCalledClickOnCurrency.current < currencyChangeDelay) {
            return;
        }
        lastCalledClickOnCurrency.current = now;

        let targetCurrency;
        if (e.target.textContent === "$") {
            targetCurrency = "USD"
            setCurrencyOrder({
                rubOrder: 1,
                usdOrder: 2,
                eurOrder: 3
            })
        } if (e.target.textContent === "₽") {
            targetCurrency = "RUB"
            setCurrencyOrder({
                rubOrder: 2,
                usdOrder: 1,
                eurOrder: 3
            })
        } if (e.target.textContent === "€") {
            targetCurrency = "EUR"
            setCurrencyOrder({
                rubOrder: 1,
                usdOrder: 3,
                eurOrder: 2
            })
        }
        
        getAllSiblings(e.target).forEach(element => {
            element.tabIndex = 0;            
        });
        e.target.tabIndex = -1;

        if (props.sellPossible === true && targetCurrency !== props.currencyOfSell) {
            setPriceToSell(convertPrice(priceToSell, activeCurrency, targetCurrency, rates))
        } if (props.sellPossible === true && targetCurrency === props.currencyOfSell) {
            setPriceToSell(props.priceToSell)
        } if (props.rentPossible === true && targetCurrency !== props.currencyOfRent) {
            setPriceToRent(convertPrice(priceToRent, activeCurrency, targetCurrency, rates))
        } if (props.rentPossible === true && targetCurrency === props.currencyOfRent) {
            setPriceToRent(props.priceToRent)
        }

        setActiveCurrency(targetCurrency);
        window.setTimeout(() => controlWrap(false), 1);
        
    }


    return(
        <>
        <h2 className="hidden">Цена и характеристики</h2>
        <dl className="priceSection">
            {
                (props.sellPossible === true) && (props.priceOnDemand === false) ?
                <div className={`priceToSell${pricesWrapped ? " wrapped" : ""}`}>
                    <dt>Продажа</dt>
                    <dd>{spacefyNumber(priceToSell)}</dd>
                </div>
                : null
            }
            {
                props.rentPossible === true && (props.priceOnDemand === false) ?
                <div className={`priceToRent${pricesWrapped ? " wrapped" : ""}`}>
                    <dt>Аренда</dt>
                    <dd>{spacefyNumber(priceToRent)}</dd>
                </div>
                : null
            }
            {
                props.priceOnDemand === true && (props.sellPossible === true) && (props.rentPossible === false) ?
                <div className={`priceToSell${pricesWrapped ? " wrapped" : ""}`}>
                    <dt>Продажа</dt>
                    <dd style={{marginBottom: "2.472rem"}}>цена по запросу</dd>
                </div>
                : null
            }
            {
                props.priceOnDemand === true && (props.rentPossible === true) && (props.sellPossible === false) ?
                <div className={`priceToSell${pricesWrapped ? " wrapped" : ""}`}>
                    <dt>Аренда</dt>
                    <dd>цена по запросу</dd>
                </div>
                : null
            }
            {
                props.priceOnDemand === true && (props.rentPossible === true) && (props.sellPossible === true) ?
                <div className={`priceToSell${pricesWrapped ? " wrapped" : ""}`}>
                    <dt>Продажа и аренда</dt>
                    <dd>цена по запросу</dd>
                </div>
                : null
            }
        </dl> 
        {
            props.priceOnDemand === false ?
            <div className="currencyButtonsContainer">
                <button className={`currencyButton ${(activeCurrency === "RUB") ? "active" : "" }`} tabIndex={0} onClick={handleClickOnCurrency} style={{"order":currencyOrder.rubOrder}}>₽</button>
                <button className={`currencyButton ${(activeCurrency === "USD") ? "active" : "" }`} tabIndex={-1} onClick={handleClickOnCurrency} style={{"order":currencyOrder.usdOrder}}>$</button>
                <button className={`currencyButton ${(activeCurrency === "EUR") ? "active" : "" }`} tabIndex={0} onClick={handleClickOnCurrency} style={{"order":currencyOrder.eurOrder}}>€</button>
            </div>
            :
            null
        }
        { props.rentOccupied === true &&
            <div className="rentOccupied x-hight-align-container">
                <p className="x-height-line">Объект сдан</p>
                <RentInformButton />
            </div>
        } 
        { props.rentOccupied !== true && 
            <hr/>
        }
        </>
    );
}

export default PriceSection;